import React from "react";
import { Link } from "react-router-dom";
import { SITE } from "../config/site";

function Footer() {
  return (
    <footer className="footer scroll-reveal">

      <div className="footer-container scroll-reveal">

        <div className="footer-grid scroll-reveal">

          {/* Left */}

          <div className="footer-about scroll-reveal">

            <div className="footer-logo scroll-reveal">

              <div className="footer-logo-icon scroll-reveal">
                SMT
              </div>

              <div className="footer-logo-text scroll-reveal">
                SMT INSTITUTE
              </div>

            </div>

            <p className="footer-description scroll-reveal">
              India's most trusted mobile repair training institute.
              25-day intensive programs in Android, iPhone and
              advanced Chip-Level Micro Soldering.
            </p>

            <div className="footer-contact scroll-reveal">

              <div>{SITE.address}</div>

              <div>{SITE.hours}</div>

              <div>

                <a href={SITE.phoneHref}>
                  {SITE.phone}
                </a>

                {" | "}

                <a href={`mailto:${SITE.email}`}>
                  {SITE.email}
                </a>

              </div>

            </div>

          </div>

          {/* Explore */}

          <div>

            <h4 className="footer-heading scroll-reveal">
              Explore
            </h4>

            <ul className="footer-links scroll-reveal">

              <li><Link to="/about">About SMT</Link></li>
              <li><Link to="/courses">All Courses</Link></li>
              <li><Link to="/curriculum">Curriculum</Link></li>
              <li><Link to="/success-stories">Success Stories</Link></li>
              <li><Link to="/reviews">Student Reviews</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>

            </ul>

          </div>

          {/* Programs */}

          <div>

            <h4 className="footer-heading scroll-reveal">
              Programs
            </h4>

            <ul className="footer-links scroll-reveal">

              <li><Link to="/courses/android">Android Repair</Link></li>
              <li><Link to="/courses/iphone">iPhone Repair</Link></li>
              <li><Link to="/courses/chip-level">Chip Level</Link></li>
              <li><Link to="/courses/reballing">Reballing</Link></li>
              <li><Link to="/courses/online">Online Classes</Link></li>
              <li><Link to="/faq">FAQ</Link></li>

            </ul>

          </div>

        </div>

        <div className="footer-bottom">

          <div>
            © {new Date().getFullYear()} SMT Institute · All Rights Reserved
          </div>

          <div className="footer-badges">

            <span>ISO 9001:2015</span>

            <span>Govt Registered</span>

            <span>Est. 2014</span>

          </div>

        </div>

      </div>

    </footer>
  );
}

export default Footer;